const tableRegex = /START_OF_TABLE[\s\S]*?END_OF_TABLE/g;
const tripleLineBreakRegex = /\n\n\n+/g;
export const removeTables = (str: string) =>
  str.replace(tableRegex, "").replace(tripleLineBreakRegex, "\n\n").trim();
